export const ITAdminSettingsTableHeader = [
  {
    field: 'pathology_procedure_code',
    headerName: 'Pathology Procedure Code',
    width: 300,
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'cdx_procedure_code',
    headerName: 'CDx Procedure Code',
    width: 300,
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'description',
    headerName: 'Display name',
    width: 458,
    headerClassName: 'super-app-theme--header',
  },
]

export const ITAdminSettingsStateList = [
  {
    field: 'state_code',
    headerName: 'State Code',
    width: 500,
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'state_name',
    headerName: 'State Name',
    width: 500,
    headerClassName: 'super-app-theme--header',
  },
]
